export const LIBRARY_COLUMN_NAMES: Record<string, string> = {
  title: 'Title',
  user: 'Creator',
  elementalTypeId: 'Type',
  createdAt: 'Created',
  updatedAt: 'Updated',
}
